<template>
	<div>
		<div class="container">
			<div class="mt-5 downloadMessage" v-if="showNotification">
				<Message :notification="notification" />
			</div>
			<DownloadRewardsCard :Heading="Heading" :ThanksForJoininDevice="ThanksForJoininDevice"
				:ThanksForJoininMobile="ThanksForJoininMobile" :appleWallet="appleWallet"
				:googlePay="googlePay" :cardNumber="cardNumber" :jwtGoogle="jwtGoogle"
				:customerName="customerName" :tier="tier" :customerId="customerId"
				:carduid="carduid" :flagLog="flagLog" />

			<p class="text pt-5">Finished downloading your digital Rewards card? <span v-on:click="signOut"
					class="hyperlink">Sign Out</span></p>
		</div>
	</div>
</template>

<script setup>
	import { ref, computed, onMounted } from 'vue'
	import { useRouter, useRoute } from 'vue-router'
	import { useStore } from 'vuex'
	import DownloadRewardsCard from '@/components/DownloadRewardsCard.vue'
	import Message from '@/components/Message.vue'
	import digitalApi from '@/services/DigitalApiClient.js'
	import gigyaWebSDK from '@/gigyaWebSDK'

	const notification = ref('')
	const appleWallet = ref('@/assets/Add_to_Apple_Wallet_rgb_US-UK.svg')
	const googlePay = ref('@/assets/Save to Google Pay - English (Dark).svg')
	const cardNumber = ref('')
	const customerName = ref('')
	const tier = ref('')
	const customerId = ref('')
	const jwtGoogle = ref('')
	const carduid = ref('')
	const flagLog = ref('R')
	const isMyBeauty = ref(false)

	const router = useRouter()
	const route = useRoute()
	const store = useStore()

    const oat = computed(() => store.state.oat);

	const showNotification = computed(() => notification.value !== '')
	const Heading = computed(() =>
		isMyBeauty.value
			? `You're officially a Rewards and MyBeauty member.`
			: 'Download your digital Rewards card'
	)
	const ThanksForJoininDevice = computed(() =>
		isMyBeauty.value
			? 'An email containing all your account details will be with you very soon. Click the button below to download your digital Rewards card to your phone.'
			: 'Thank you for joining Harrods Rewards. Click the button below to download your digital Rewards card. You will then need to send it to your mobile device to be able to use it.'
	)
	const ThanksForJoininMobile = computed(() =>
		isMyBeauty.value
			? 'An email containing all your account details will be with you very soon. Click the button below to download your digital Rewards card to your phone.'
			: 'Thank you for joining Harrods Rewards. Click the button below to download your digital Rewards card to your phone.'
	)

	function signOut() {
		gigyaWebSDK.accounts.session.verify({
			callback: function (response) {
				if (response.errorCode == 0) {
					const params = {
						callback: function () {
							digitalApi
								.clearUser()
								.then(function () {
									store.dispatch('reset')
									router.push({ path: `/` })
								})
								.catch(function (error) {
									console.log(error)
									router.push({ path: `/` })
								})
						}
					}
					gigyaWebSDK.accounts.logout(params)
				} else {
					store.dispatch('reset')
					router.push({ path: `/` })
				}
			}
		})
	}

	onMounted(async () => {
		if (!oat.value) {
			console.log('No OAT found, redirecting');
            router.push({ name: 'SignInToRewards' })
            return
		}

        // Artificial delay of 3 seconds to allow async downstream CDC -> CDP replication to happen
		await new Promise(resolve => setTimeout(resolve, 3000));

		let attempts = 0
		const maxAttempts = 3
		let result = null

		while (attempts < maxAttempts) {
			try {
				result = await digitalApi.getUser(oat.value?.AccessKey, oat.value?.m)
				if (result.email != null && result.email !== '') {
					isMyBeauty.value = result.isMyBeautyMember
					notification.value =
						'Please verify your account. We’ve sent an email to ' +
						result.email +
						'. Please check your inbox for the verification link. If you no longer have access to this email address, please call our Customer Service team on +44 (0)20 3626 7911'

					cardNumber.value = result.cardNumber
					customerName.value = result.firstName + ' ' + result.lastName
					tier.value = result.tier
					customerId.value = result.id
					carduid.value = result.carduid

					try {
						const googleCardToken = await digitalApi.getGoogleCardToken(
							result.id,
							oat.value?.AccessKey,
							oat.value?.g
						)
						jwtGoogle.value = googleCardToken
					} catch (error) {
						console.log('Error fetching Google Card Token:', error)
					}
					return
				} else {
					router.push({ name: 'SignInToRewards' })
					return
				}
			} catch (error) {
				attempts++
				console.log(`Attempt ${attempts} failed:`, error)
				if (attempts < maxAttempts) {
					await new Promise(resolve => setTimeout(resolve, 5000))
				}
			}
		}
		router.push({ name: 'SignInToRewards' })
		// Optionally: this.$appInsights.trackException({exception: error});
	})
</script>

<style lang="scss" scoped></style>